import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

// Async thunk for editing Levels
export const editLevels = createAsyncThunk(
  "levels/editLevels",
  async ({ id, updatedLevel }, { rejectWithValue }) => {
    try {
      const response = await axios.patch(
        `${apiUrl}/UserLevels/${id}/`,
        updatedLevel,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response?.data?.icon) {
        return rejectWithValue(error.response.data.icon[0]);
      }
      return rejectWithValue(
        error.response?.data?.message || error.message || "Something went wrong"
      );
    }
  }
);

const levelSlice = createSlice({
  name: "levels",
  initialState: {
    levels: [], // Store for all levels
    editStatus: "idle", // Status for edit operation
    editError: null, // Error for edit operation
  },
  reducers: {
    resetEditStatus: (state) => {
      state.editStatus = "idle";
      state.editError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle editLevels action
      .addCase(editLevels.pending, (state) => {
        state.editStatus = "loading";
        state.editError = null;
      })
      .addCase(editLevels.fulfilled, (state, action) => {
        state.editStatus = "succeeded";
        const updatedLevel = action.payload;
        const index = state.levels.findIndex(
          (level) => level.id === updatedLevel.id
        );
        if (index !== -1) {
          state.levels[index] = { ...state.levels[index], ...updatedLevel };
        }
      })
      .addCase(editLevels.rejected, (state, action) => {
        state.editStatus = "failed";
        state.editError = action.payload;
      });
  },
});

export const { resetEditStatus } = levelSlice.actions;

export default levelSlice.reducer;
